export default {
    /**
     * Format a date to a readable format.
     *
     * @param date
     *
     * @return The human readable date.
     */
    readableDate(date: string) {
        if (!date) {
            return '';
        }
        const options: Intl.DateTimeFormatOptions = {year: 'numeric', month: 'long', day: 'numeric'};
        return new Date(date).toLocaleDateString('fr-FR', options);
    },

    /**
     * Format on the fly a phone number input.
     */
    readablePhone(input?: string) {
        if (!input) {
            return '';
        }

        return input
            .replace('+33', '0')
            .replace(/\D+/g, '')
            .replace(/(\d{2})\s?(\d{0,2})?\s?(\d{0,2})?\s?(\d{0,2})?\s?(\d{0,2})?/, (...args) => {
                return args.slice(1, 6).filter(arg => arg !== undefined).join(' ');
            })
            .substring(0, 14);
    },

    apiPhone(input: string) {
        const frenchCode = '+33';
        let phone = input.replace(/ /g, '');

        if (!phone.startsWith(frenchCode) && (phone.search('0') === 0 && phone.length === 10)) {
            phone = phone.replace(phone.substring(0, 1), frenchCode);
        }

        return phone;
    },

    /**
     * Format a zip code to match the 5 characters french format
     */
    formatZipCode(postalCode: string) {
        if (!postalCode || (postalCode.length >= 5)) {
            return postalCode.substring(0, 5);
        }
        const regex = new RegExp('[0-9]{' + postalCode.toString().length + '}');
        if (regex.test(postalCode)) {
            if (postalCode.toString().length >= 1 && postalCode.toString().length < 5) {
                return postalCode.toString() + '0'.repeat(5 - postalCode.toString().length);
            }
        }
    },
    /**
     * Check if the phone number is valid.
     *
     * @param phone - The phone number.
     *
     * @returns Whether the phone is valid.
     */
    phoneIsValid(phone: string) {
        const regex = /^(0|\+33)(6|7)[0-9]{8}$/;
        return regex.test(phone.replace(/\s/g, ''));
    },

    /**
     * Format a patient name to a standardized format.
     * @param patient - The patient object containing first and last name.
     */
    patientName(patient: { first_name: string, last_name: string }): string {
        return patient.first_name.charAt(0).toUpperCase()
            + patient.first_name.slice(1).toLowerCase()
            + ' ' + patient.last_name.toUpperCase();
    },

    /**
     * The civility matching a gender, empty when the gender is unknown.
     *
     * The API exposes the gender either as a code (1 = male) or as a slug,
     * depending on the resource.
     *
     * @param gender - The gender code or slug.
     */
    civility(gender?: number | string | null): string {
        if (gender === undefined || gender === null || gender === '') {
            return '';
        }

        return gender === 1 || gender === '1' || gender === 'male' ? 'Monsieur' : 'Madame';
    },
};

/** Format a price */
export const price = (value: number): string =>
{
    const formatter = new Intl.NumberFormat('fr-FR', {
        style: 'currency',
        currency: 'EUR'
    });
    return formatter.format(value);
};
